import { autoserialize } from 'cerialize';

export class CharitySurvey {
  @autoserialize reason?: string;
  @autoserialize comment?: string;

  constructor(payload?: ICharitySurvey) {
    this.reason = payload?.reason;
    this.comment = payload?.comment;
  }
}

export interface ICharitySurvey {
  reason?: string;
  comment?: string;
}
